// import _ from "lodash";
import Indicador from "..";
import AFCEditFields from "./components/AFCEditFields";
import { AFCParamFields } from "./components/AFCParamFields";
import ReportSummary from "./reports/summary";

import apontamentoReport from "./reports/index";

// import adfReportSummary from "./reports/summary";

export default class AFC extends Indicador {
    static get fullName() {
        return "Aferição de Corretivo";
    }

    static get abbrev() {
        return "Af. C";
    }

    static get field() {
        return "afc";
    }

    static get multTipo() {
        return true
    }

    static get legacyApontamentoMap() {
        return {
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",


            seletorInsumo: "insumo",
            dosagemRecomendada: "dosagemRecomendada",
            larguraFaixa: "faixaTrabalho",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    pesagem: "pesagem",
                    observacaoColeta: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",
            afericao: "afericao",
            mediaColetas: "totalPesagem",
            dosePorMetro: "doseMetro",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            psCintervaloAderenciaMinimoManual: "manual.intervaloMin",
            psCintervaloAderenciaMaximoManual: "manual.intervaloMax",
            psCmetrosLinearesAmostraManual: "manual.metrosLinearesAmostra",
            psCmetrosLinearesHectareManual: "manual.metrosLinearesHectare",
            psCmetaManual: "manual.meta",

            psCintervaloAderenciaMinimoMecanizado: "mecanizado.intervaloMin",
            psCintervaloAderenciaMaximoMecanizado: "mecanizado.intervaloMax",
            psCmetrosLinearesAmostraMecanizado: "mecanizado.metrosLinearesAmostra",
            psCmetrosLinearesHectareMecanizado: "mecanizado.metrosLinearesHectare",
            psCmetaMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <AFCParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <AFCEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;
        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }
        //
        let totalPesagem = 0;
        let doseMetro = 0;
        let afericao = 0;
        let conformidade = 0

        for (const coleta of apontamento.coletas) {
            if (coleta.pesagem) {
                totalPesagem += f(coleta.pesagem);
            }
        }

        let metrosLinearesAmostra = f(params.metrosLinearesAmostra)
        let metrosLinearesHectare = f(params.metrosLinearesHectare)
        let dosagemRecomendada = apontamento.dosagemRecomendada
        let faixaTrabalho = apontamento.faixaTrabalho

        if (totalPesagem && metrosLinearesAmostra && faixaTrabalho) {
            let divisor = f(metrosLinearesAmostra) * f(faixaTrabalho)

            if (divisor !== 0) {
                doseMetro = f(totalPesagem) / divisor
                doseMetro = doseMetro.toFixed(3)
            }
        }

        if (doseMetro && metrosLinearesHectare) {
            afericao = f(doseMetro) * f(metrosLinearesHectare)
            afericao = afericao.toFixed(3)
        }

        if (dosagemRecomendada && afericao) {
            const rawConformidade = (f(afericao) / f(dosagemRecomendada)) * 100;
            apontamento.acima = rawConformidade > f(params.intervaloMax) ? 1 : 0;
            apontamento.abaixo = rawConformidade < f(params.intervaloMin) ? 1 : 0;
            conformidade = rawConformidade > 100 ? rawConformidade - 200 : rawConformidade;
            if (conformidade > 200) {
                conformidade = 0;
            }

            if (conformidade < 0) {
                conformidade = conformidade * (-1)
            }
            conformidade = conformidade.toFixed(3)
        } else {
            apontamento.acima = 0;
            apontamento.abaixo = 0;
            conformidade = 0
        }

        apontamento.totalPesagem = totalPesagem
        apontamento.doseMetro = doseMetro
        apontamento.afericao = afericao

        return conformidade;
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 94.73, 100, 103.15);
    }

    static getResultStr(apontamento) {
        return "Aferição: " + apontamento.afericao +
            ", Dose/M: " + apontamento.doseMetro +
            " e Pesagem Total: " + apontamento.totalPesagem
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }
}
